<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('bloodBank.add-blood-transfusion')
          : $t('bloodBank.edit-blood-transfusion')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="12" style="font-weight: bold">
            <AutoComplete
              v-model="EditForm.patient_card_id"
              :label="$t('common.Patient Card')"
              :placeholder="$t('common.Patient Card')"
              param-query="patient.name"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient.name"
              :isRelational="true"
              :otherQuery="`include=patient&filter[type]=emergency,IN&filter[is_active]=true`"
              keyword="patient"
            />
            <p class="text-danger mt-1">{{ errorForm.patient_card_id }}</p>
          </b-col>
          <b-col md="12" style="font-weight: bold">
            <AutoComplete
              v-model="EditForm.blood_transfusion_type_id"
              :label="$t('bloodBank.blood-transfusion-type')"
              :placeholder="$t('bloodBank.blood-transfusion-type')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="bloodTransfusionTypes"
              text-title="name"
              keyword="name"
            />
            <p class="text-danger mt-1">
              {{ errorForm.blood_transfusion_type_id }}
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4" style="font-weight: bold">
            <b-form-group
              :label="$t('bloodBank.patient-abo')"
              label-for="patient_abo"
            >
              <v-select
                v-model="EditForm.patient_abo"
                :options="aboOptions"
                placeholder="A, B, AB, O"
              />
              <p class="text-danger mt-1">{{ errorForm.patient_abo }}</p>
            </b-form-group>
          </b-col>

          <b-col md="4" style="font-weight: bold">
            <b-form-group
              :label="$t('bloodBank.patient-rh')"
              label-for="patient_rh"
            >
              <v-select
                v-model="EditForm.patient_rh"
                :options="rhOptions"
                placeholder="Positive, Negative"
              />
              <p class="text-danger mt-1">{{ errorForm.patient_rh }}</p>
            </b-form-group>
          </b-col>

          <b-col md="4" style="font-weight: bold">
            <b-form-group
              :label="$t('bloodBank.number-of-units')"
              label-for="number_of_units"
            >
              <b-form-input
                type="number"
                v-model="EditForm.number_of_units"
                :placeholder="$t('bloodBank.number-of-units')"
              />
              <p class="text-danger mt-1">{{ errorForm.number_of_units }}</p>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- <b-row>
                    <b-col md="12">
                        <b-form-group :label="$t('bloodBank.inserted-at')" label-for="inserted_at">
                            <datepicker v-model="EditForm.inserted_at" :calendar-button="true" :clear-button="true"
                                :bootstrap-styling="true" class="datebtn2" placeholder="YYYY-MM-DD"></datepicker>
                        </b-form-group>
                        <p class="text-danger mt-1">{{ errorForm.inserted_at }}</p>
                    </b-col>
                </b-row> -->
        <b-row> </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{
            createMode ? $t("common.add") : $t("common.edit")
          }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-card :title="$t('bloodBank.filter-blood-store')">
      <div>
        <b-row class="mt-3">
          <b-col md="4" cols="6" style="font-weight: bold">
            <AutoComplete
              v-model="patient_card_id"
              :label="$t('common.Patient Card')"
              :placeholder="$t('common.Patient Card')"
              param-query="patient.name"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient.name"
              :isRelational="true"
              :otherQuery="`include=patient&filter[type]=emergency,IN&filter[is_active]=true`"
              keyword="patient"
            />
          </b-col>
          <b-col md="3" cols="4" style="font-weight: bold">
            <AutoComplete
              v-model="blood_transfusion_type_id"
              :label="$t('bloodBank.blood-transfusion-type')"
              :placeholder="$t('bloodBank.blood-transfusion-type')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="bloodTransfusionTypes"
              text-title="name"
              keyword="name"
            />
          </b-col>
          <b-col md="2" cols="4" style="font-weight: bold">
            <b-form-group
              :label="$t('bloodBank.patient-abo')"
              label-for="patient_abo"
            >
              <v-select
                v-model="patient_abo"
                :options="aboOptions"
                placeholder="A, B, AB, O"
              />
            </b-form-group>
          </b-col>

          <b-col md="3" cols="4" style="font-weight: bold">
            <b-form-group
              :label="$t('bloodBank.patient-rh')"
              label-for="patient_rh"
            >
              <v-select
                v-model="patient_rh"
                :options="rhOptions"
                placeholder="Positive, Negative"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2 mb-3">
          <b-col md="4" cols="6" style="font-weight: bold">
            <b-form-group
              :label="$t('bloodBank.search-from-to-by')"
              label-for="rh"
            >
              <v-select
                v-model="searchDate"
                :options="searchFromToBy"
                :placeholder="$t('bloodBank.search-from-to-by')"
              />
            </b-form-group>
          </b-col>

          <b-col md="4" cols="6" style="font-weight: bold">
            <b-form-group
              v-if="selectedSearch.key === 'created_at'"
              :label="$t(`${selectedSearch.label || ''} From`)"
              label-for="production_date"
            >
              <b-form-datepicker
                v-model="from_date"
                :placeholder="$t('common.select-date')"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                locale="en"
                class="dark-datepicker"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
            <!-- <b-form-group v-else :label="$t('bloodBank.choose-value-max') + ' ' + $t(selectedSearch.label)"
                            label-for="from_value">
                            <b-form-input v-model="from_value" type="number"></b-form-input>
                        </b-form-group> -->
          </b-col>
          <b-col md="4" cols="6" style="font-weight: bold">
            <b-form-group
              v-if="selectedSearch.key === 'created_at'"
              :label="$t(`${selectedSearch.label || ''} To`)"
              label-for="expiration_date"
            >
              <b-form-datepicker
                v-model="to_date"
                :placeholder="$t('common.select-date')"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                locale="en"
                class="dark-datepicker"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>

            <!-- <b-form-group v-else :label="$t('bloodBank.choose-value-min') + ' ' + $t(selectedSearch.label)"
                            label-for="to_value">
                            <b-form-input v-model="to_value" type="number"></b-form-input>
                        </b-form-group> -->
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getBloodTransfusions()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
            <!-- <b-button variant="primary" v-print="IVF" class="mx-2">
                            {{ $t("surgery.Print-Hospital-Expenses") }}
                        </b-button> -->
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("bloodBank.blood-transfusions-table") }}</h2>
          <b-button variant="primary" @click="show(EditForm, 'create')">
            {{ $t("bloodBank.add-blood-transfusions") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="bloodBottleTableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(patient_card.patient.name)="data">
            <p class="text-nowrap" style="font-size: 1.2rem; font-weight: bold">
              {{ getNestedProperty(data.item, "patient_card.patient.name") }}
            </p>
          </template>

          <template #cell(patient_abo)="data">
            <p style="font-size: 1.2rem; font-weight: bold">
              {{ data.item.patient_abo }}
            </p>
          </template>
          <template #cell(patient_rh)="data">
            <p style="font-size: 1.2rem; font-weight: bold">
              {{ data.item.patient_rh }}
            </p>
          </template>
          <template #cell(number_of_units)="data">
            <p style="font-size: 1.2rem; font-weight: bold">
              {{ data.item.number_of_units }}
            </p>
          </template>

          <template #cell(blood_bottles.bottle_identifier)="data">
            <ol>
              <li
                v-for="bottle in data.item.blood_bottles"
                :key="bottle.id"
                class="mb-1"
              >
                <b-badge
                  variant="secondary"
                  style="font-size: 1rem; font-weight: bold; color: #000"
                  >{{ bottle.bottle_identifier }}</b-badge
                >
              </li>
            </ol>
          </template>

          <template #cell(blood_compatibilities.final_result)="data">
            <ol>
              <li
                v-for="result in data.item.blood_compatibilities"
                :key="result.id"
                class="mb-1"
              >
                <b-badge
                  :variant="
                    result.final_result === 'compatible' ? 'success' : 'danger'
                  "
                  style="font-size: 1rem; color: #000"
                  >{{ result.final_result }}</b-badge
                >
              </li>
            </ol>
          </template>

          <template #cell(blood_transfusion_type_id)="data">
            <p style="font-size: 1.2rem; font-weight: bold">
              {{ getTransfusionType(data.item.blood_transfusion_type_id) }}
            </p>
          </template>
          <template #cell(created_at)="data">
            <p style="font-size: 1.2rem; font-weight: bold; text-wrap: nowrap">
              {{ data.item.created_at }}
            </p>
          </template>

          <template #cell(sample_matching)="data">
            <b-button
              size="sm"
              pill
              variant="outline-secondary"
              @click="
                $router.push({
                  name: 'blood-compatibilities',
                  params: {
                    blood_transfusion_id: data.item.id,
                    patient_name: getNestedProperty(
                      data.item,
                      'patient_card.patient.name'
                    ),
                    patient_abo: data.item.patient_abo,
                    patient_rh: data.item.patient_rh,
                    isSho: false,
                  },
                })
              "
            >
              {{ $t("bloodBank.sample-matching") }}
            </b-button>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                deletePerm="get-bloodTransfusion"
                editPerm="get-bloodTransfusion"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getBloodTransfusions()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>

    <IVF :data="data" type="Hospital" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput, { async } from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const IVF = () => import("@/components/printables/IVF.vue");
const Doctor = () => import("@/components/printables/Doctor.vue");
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import axios from "axios";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    IVF,
    Doctor,
    AutoComplete,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_id: "",
        patient_abo: "",
        patient_rh: "",
        blood_transfusion_type_id: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        patient_card_id: "",
        patient_abo: "",
        patient_rh: "",
        blood_transfusion_type_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      bloodBottleTableColumns: [
        {
          key: "patient_card.patient.name",
          sortable: true,
          label: this.$t("bloodBank.patient-name"),
        },
        {
          key: "blood_transfusion_type_id",
          sortable: true,
          label: this.$t("bloodBank.blood-transfusion-type"),
        },
        {
          key: "patient_abo",
          sortable: true,
          label: this.$t("bloodBank.patient-abo"),
        },
        {
          key: "patient_rh",
          sortable: true,
          label: this.$t("bloodBank.patient-rh"),
        },

        {
          key: "number_of_units",
          sortable: true,
          label: this.$t("bloodBank.number-of-units"),
        },
        {
          key: "blood_bottles.bottle_identifier",
          sortable: true,
          label: this.$t("bloodBank.bottle-identifier"),
        },
        {
          key: "blood_compatibilities.final_result",
          sortable: true,
          label: this.$t("bloodBank.final-result"),
        },
        {
          key: "sample_matching",
          sortable: true,
          label: this.$t("bloodBank.sample-matching"),
        },

        {
          key: "Actions",
          label: this.$t("common.actions"),
          thStyle: { width: "150px" },
        },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created-at"),
        },
      ],

      aboOptions: ["A", "B", "AB", "O"],
      rhOptions: ["Positive", "Negative"],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      page: 1,
      IVF: {
        id: "IVF",
      },

      abo: "",
      rh: "",
      production_date: "",
      expiration_date: "",
      bottle_identifier: "",
      inserted_at: "",
      searchFromToBy: [
        {
          key: "created_at",
          label: this.$t("bloodBank.created_at"),
          from: "created_at-ge",
          to: "created_at-le",
        },
        // {
        //     key: "room_temperature",
        //     label: this.$t("bloodBank.room-temperature"),
        //     from: "room_temperature-ge",
        //     to: "room_temperature-le",
        // },
        // {
        //     key: "incubator_temperature",
        //     label: this.$t("bloodBank.incubator-temperature"),
        //     from: "incubator_temperature-ge",
        //     to: "incubator_temperature-le",
        // },
        // {
        //     key: "number_of_units",
        //     label: this.$t("bloodBank.number-of-units"),
        //     from: "number_of_units-ge",
        //     to: "number_of_units-le",
        // },
      ],
      statusOptions: ["available", "dispensed"],
      searchDate: "",
      selectedSearch: "",
      from_date: "",
      to_date: "",
      status: "",
      from_value: "",
      to_value: "",
      blood_transfusion_type_id: "",
      patient_card_id: "",
      patient_abo: "",
      patient_rh: "",
      number_of_units: "",
      room_temperature: "",
      incubator_temperature: "",
      transfusionTypes: [],
    };
  },
  mounted() {
    this.getTransfusionTypeList();
    this.getBloodTransfusions();
  },
  watch: {
    searchDate(newVal) {
      this.from_date = "";
      this.from_value = "";
      this.to_date = "";
      this.to_value = "";
      this.selectedSearch = newVal || "";
    },
  },
  methods: {
    async getTransfusionTypeList() {
      await this.getList(`/bloodTransfusionTypes`);
      this.transfusionTypes = this.all_data.data;
      console.log("this.transfusionTypes", this.transfusionTypes);
    },
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      // console.log("result", result);
      return result;
    },
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      console.log("item", item);
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.patient_card_id = item.patient_card_id;
        this.EditForm.patient_abo = item.patient_abo;
        this.EditForm.patient_rh = item.patient_rh;
        this.EditForm.blood_transfusion_type_id =
          item.blood_transfusion_type_id;
        this.EditForm.number_of_units = item.number_of_units;

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    async getBloodTransfusions() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/bloodTransfusions?page=${this.page}&take=${
        this.searchDate &&
        (this.from_date || this.to_date || this.from_value || this.to_value)
          ? 1000
          : 15
      }&sort=-id&include[]=bloodBottles&include[]=bloodCompatibilities&include[]=patientCard&include[]=transfusionType`;

      if (this.patient_card_id) {
        url += `&filter[patient_card_id]=${this.patient_card_id}`;
      }
      if (this.patient_abo) {
        url += `&filter[patient_abo]=${this.patient_abo}`;
      }
      if (this.patient_rh) {
        url += `&filter[patient_rh]=${this.patient_rh}`;
      }
      if (this.blood_transfusion_type_id) {
        url += `&filter[blood_transfusion_type_id]=${this.blood_transfusion_type_id}`;
      }

      if (this.from_date) {
        url += `&filter[${this.searchDate.from}]=${this.formatDate(
          this.from_date
        )}`;
      }
      if (this.to_date) {
        url += `&filter[${this.searchDate.to}]=${this.formatDate(
          this.to_date
        )}`;
      }

      if (this.from_value) {
        url += `&filter[${this.searchDate.from}]=${this.from_value}`;
      }
      if (this.to_value) {
        url += `&filter[${this.searchDate.to}]=${this.to_value}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
      // console.log("this.data", this.data);
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/bloodTransfusions/${this.deleteForm.id}`)
        .then((response) => {
          this.getBloodTransfusions();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text:
                "deleted " +
                this.deleteForm.bottle_identifier +
                " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.bottle_identifier,
            },
          });
        });
    },

    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.patient_card_id = "";
      this.errorForm.patient_abo = "";
      this.errorForm.patient_rh = "";
      this.errorForm.blood_transfusion_type_id = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.patient_card_id) {
        count++;
        this.errorForm.patient_card_id =
          "The patient card id field is required.";
      }
      if (!this.EditForm.patient_abo) {
        count++;
        this.errorForm.patient_abo = "The ABO field is required.";
      }
      if (!this.EditForm.patient_rh) {
        count++;
        this.errorForm.patient_rh = "The RH field is required.";
      }
      if (!this.EditForm.blood_transfusion_type_id) {
        count++;
        this.errorForm.blood_transfusion_type_id =
          "The blood transfusion type field is required.";
      }

      console.log("editForm", this.EditForm);
      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/bloodTransfusions`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              console.log("this.expenses", this.expenses);
              this.getBloodTransfusions();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/bloodTransfusions/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              this.getBloodTransfusions();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    getTransfusionType(id) {
      const transfusionType = this.transfusionTypes;
      console.log("transfusionType1111", transfusionType);

      if (id) {
        // console.log("id", id);
        const writeType = transfusionType.find((type) => type.id === id);
        console.log("writeType", writeType);
        return writeType.name;
      }

      //   return transfusionType;
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
